import {Button, Card, Result} from "antd";
import {useHistory} from "react-router-dom";

export default function ResetPasswordSuccess() {
    const history = useHistory();

    const redirectLogin = () => {
        history.push('/app/login')
    }

    return (
        <>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', backgroundColor: '#edf2f8'}}>
                <Card title={'Reset Password'} style={{minWidth: 400}}>
                    <Result
                        status="success"
                        subTitle="Your account password has been reset successfully."
                        title="Success!"
                        extra={[
                            <Button type="primary" key="console" onClick={redirectLogin}>
                                Login
                            </Button>
                        ]}
                    />
                </Card>
            </div>
        </>
    )
}